import React, { Component } from "react";

class TimeSwitcher extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { timespan0Label, timespan1Label, timespan2Label, title, active, onClick } = this.props;

    return (
      <div>
        <p className="text-gray hidden">{title}</p>
        <div className="flex my-0 shadow-md">
          <button
            onClick={() => onClick(0)}
            title={timespan0Label}
            className={
              (active === 0)
                ? "btn-switch text-white bg-red active:bg-red-darker rounded-l-md"
                : "btn-switch text-gray-lighter bg-white active:bg-gray-lightest active:border-2 rounded-l-md"
            }
          >
            <span className="block whitespace-nowrap overflow-ellipsis">
              {timespan0Label}
            </span>
          </button>
          <button
            onClick={() => onClick(1)}
            title={timespan1Label}
            className={
              (active === 1)
                ? "btn-switch text-white bg-red active:bg-red-darker "
                : "btn-switch text-gray-lighter bg-white active:bg-gray-lightest active:border-2 "
            }
          >
            <span className="block whitespace-nowrap overflow-ellipsis">
              {timespan1Label}
            </span>
          </button>
          <button
            onClick={() => onClick(2)}
            title={timespan2Label}
            className={
              (active === 2)
                ? "btn-switch text-white bg-red active:bg-red-darker rounded-r-md"
                : "btn-switch text-gray-lighter bg-white active:bg-gray-lightest active:border-2 rounded-r-md"
            }
          >
            <span className="block whitespace-nowrap overflow-ellipsis">
              {timespan2Label}
            </span>
          </button>
        </div>
      </div>
    );
  }
}

export default TimeSwitcher;
